<template>
	<div class="container">
		<div class="row justify-center">
			<div class="col-md-8">
				<div class="panel">
					<div class="panel-title">
						<div class="panel-heading">Login</div>
					</div>
					<div class="panel-body">
						<ui-notice v-if="error" type="warning" icon="fas fa-exclamation-circle" msg="Invalid username or password!"/>

						<ui-form ref="form" @submit.prevent="submit">
							<ui-text-box-field
								v-model="info.username"
								:rules="rules.username"
								label="Username"
								prepend-icon="fas fa-user"
								:autofocus="autofocus">
							</ui-text-box-field>

							<ui-text-box-field
								v-model="info.password"
								:rules="rules.password"
								password
								label="Password"
								prepend-icon="fas fa-lock">
							</ui-text-box-field>
						</ui-form>
					</div>
					<div class="panel-footer">
						<ui-button color="primary" @click="submit" :loading="loading">Submit</ui-button>
						<span class="flex-spacer"></span>
						<ui-button color="text" href="/admin/recovery/forgot_password">Forgot Password?</ui-button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { createApi } from 'igolf/shared/api';

const api = createApi('/admin');

export default {

	props: {
		autofocus: { type: Boolean, default: false }
	},

	data()
	{
		return {
			error: false,
			loading: false,

			info: {
				username: '',
				password: '',
			},

			rules: {
				username: [ v => !!v || 'Please enter your username' ],
				password: [ v=> !!v || 'Please enter your password' ],
			}
		}
	},

	methods: {
		async submit()
		{
			if (!this.$refs.form.validate())
				return;

			this.loading = true;
			this.error = false;

			try
			{
				var result = await api.post('/authenticate', this.info);
				
				this.error = !result.data.success;

				if (!this.error)
					document.location = '/admin';
			}
			finally
			{
				this.loading = false;
			}
		}
	},
}
</script>